/**
 * @generated SignedSource<<fcc24241712f9231c45d25ee33b79256>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignalPriority = "DEFAULT" | "HIGH" | "LOW" | "URGENT";
export type WorkspaceSignalEditMainPrioritySelectorSetPriorityMutation$variables = {
  id: string;
  priority: SignalPriority;
};
export type WorkspaceSignalEditMainPrioritySelectorSetPriorityMutation$data = {
  readonly signalWorkspace: {
    readonly updatePriority: {
      readonly id: string;
      readonly priority: SignalPriority;
      readonly updatedAtDate: {
        readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
      } | null;
      readonly updatedBy: {
        readonly id: string;
        readonly name: string;
      } | null;
    };
  };
};
export type WorkspaceSignalEditMainPrioritySelectorSetPriorityMutation$rawResponse = {
  readonly signalWorkspace: {
    readonly updatePriority: {
      readonly id: string;
      readonly priority: SignalPriority;
      readonly updatedAtDate: {
        readonly __isDate: "UnzonedDate";
        readonly isoString: string;
      } | null;
      readonly updatedBy: {
        readonly id: string;
        readonly name: string;
      } | null;
    };
  };
};
export type WorkspaceSignalEditMainPrioritySelectorSetPriorityMutation = {
  rawResponse: WorkspaceSignalEditMainPrioritySelectorSetPriorityMutation$rawResponse;
  response: WorkspaceSignalEditMainPrioritySelectorSetPriorityMutation$data;
  variables: WorkspaceSignalEditMainPrioritySelectorSetPriorityMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "priority"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "newPriority",
    "variableName": "priority"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priority",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "updatedBy",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceSignalEditMainPrioritySelectorSetPriorityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "updatePriority",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "updatedAtDate",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FormattedDate"
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceSignalEditMainPrioritySelectorSetPriorityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "updatePriority",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "updatedAtDate",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isoString",
                        "storageKey": null
                      }
                    ],
                    "type": "Date",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2c5f611073d36c0ce6f22ad73cc18a44",
    "id": null,
    "metadata": {},
    "name": "WorkspaceSignalEditMainPrioritySelectorSetPriorityMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceSignalEditMainPrioritySelectorSetPriorityMutation(\n  $id: ID!\n  $priority: SignalPriority!\n) {\n  signalWorkspace(id: $id) {\n    updatePriority(newPriority: $priority) {\n      id\n      priority\n      updatedAtDate {\n        ...FormattedDate\n      }\n      updatedBy {\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "d058c8071d900b08439f22c1d2690b75";

export default node;
